import { privateApi } from 'services';
import {
    ConversationalAgent,
    ConversationalAgentCollection,
    CreateConversationalAgentBody,
    UpdateConversationalAgentBody,
    SimulateConversationRequest,
    SimulateConversationResponse,
} from './types';

const create = async (businessAccountId: string, createAgent: CreateConversationalAgentBody): Promise<void> =>
    privateApi.post<void>(`business-accounts/${businessAccountId}/leads/conversational-agents`, createAgent);

const fetchCollection = async (businessAccountId: string): Promise<ConversationalAgentCollection> =>
    privateApi.get<ConversationalAgentCollection>(`business-accounts/${businessAccountId}/leads/conversational-agents`);

const fetchSingle = async (agentId: string): Promise<ConversationalAgent> =>
    privateApi.get<ConversationalAgent>(`conversational-agents/${agentId}`);

const enable = async (agentId: string): Promise<void> =>
    privateApi.post<void>(`conversational-agents/${agentId}/enable`, {});

const disable = async (agentId: string): Promise<void> =>
    privateApi.post<void>(`conversational-agents/${agentId}/disable`, {});

const update = async (agentId: string, updateAgent: UpdateConversationalAgentBody): Promise<void> =>
    privateApi.put<void>(`conversational-agents/${agentId}`, updateAgent);

const simulateConversation = async (
    agentId: string,
    requestBody: SimulateConversationRequest,
): Promise<SimulateConversationResponse> =>
    privateApi.post<SimulateConversationResponse>(
        `conversational-agents/${agentId}/simulate-conversation`,
        requestBody,
    );

export const ConversationalAgentGateway = {
    create,
    fetchCollection,
    fetchSingle,
    enable,
    disable,
    update,
    simulateConversation,
};
